'use strict';

var _TagManager = require('./TagManager');

var _TagManager2 = _interopRequireDefault(_TagManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _TagManager2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-gtm-module/dist/index.js
// module id = 570
// module chunks = 0